
import React, { useState } from "react";
import { Link } from "react-router-dom";
import SRList from "../../component/List";
import AkkhorLayout from "../../layout/akkhor";
import { checkRole } from "../../model";
import { useSelector } from "react-redux";

export default function DanhSachCheckin() {
    const { user } = useSelector((state) => state.auth);
    const [params, setParam] = useState('');
    const [title, setTitle] = useState();
    const [filterShow, setFilterShow] = useState(false)
    const role_follow = checkRole(user, 'checkin', 'follow');

    const handleSubmit = (e) => {
        e.preventDefault();
        let _param = ''
        if (title !== '') _param += "&title=" + title
        setParam(_param);
    };


    let columns = [
        { name: "id", label: "ID", options: { filter: false, sort: true } },
        { name: "title", label: "Tiêu đề" },
        { name: "datecreate", label: "Ngày tạo" },
        
        role_follow ?  {
            name: "id", label: "Chi tiết",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <a className="btn btn-sm btn-primary text-white" href={"/theo-doi-checkin/"+value}><i className="far fa-eye"></i> Xem chi tiết</a>
                },
            }
        }:{ name: "datemodified", label: "Ngày sửa" },,
    ];

    return (<AkkhorLayout idrole="checkin">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Danh sách Checkin
                </li>
            </ul>
        </div>
        <div className="card card-filter mb-3">
            <div className="card-header">
                <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
                    <div className="mr-auto">
                        <h3 className="title">Tìm kiếm</h3>
                    </div>
                    <button className="btn btn-sm btn-defaul" onClick={() => setFilterShow(!filterShow)}><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
                </div>
            </div>
            <div className={filterShow ? "card-body" : 'hidden-filter'}>
                <form className="new-added-form" method="get" >
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-6 col-12 form-group">
                            <label>Tiêu đề</label>
                            <input type="text" placeholder="Tên ca" value={title} onChange={(e) => setTitle(e.target.value)} className="form-control height32" autoComplete="off" />
                        </div>
                        <div className="col-12 ">
                            <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <SRList name="checkin" linkaction="checkin" idrole="checkin" params={params} defaultLimit={50} serverSide={true} columns={columns} ></SRList>
    </AkkhorLayout>);
}
